import { render, staticRenderFns } from "./VideoScript.vue?vue&type=template&id=c0dce1f6&scoped=true&"
import script from "./VideoScript.vue?vue&type=script&lang=js&"
export * from "./VideoScript.vue?vue&type=script&lang=js&"
import style0 from "./VideoScript.vue?vue&type=style&index=0&id=c0dce1f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0dce1f6",
  null
  
)

export default component.exports